
import { mixins } from 'vue-class-component'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { ChildComponentMixin } from '@/mixins'
import { AppSwitch } from '@/components'

@Component({
    components: { AppSwitch },
})
export default class AppSwitchForm extends mixins(
    ChildComponentMixin,
) {
    @Prop({ default: false }) public value!: boolean
    @Prop() private title!: string

    @Emit('input')
    private toggleForm(isOpen: boolean) {
        return isOpen
    }
}
